import { Container } from '@mantine/core'
import { MyMap } from '@/components/MyMap/MyMap'

export function HomePage() {

  return (
    <Container size="xl"  >
      
      <MyMap />

    </Container>
  )
}